import { get, isFunction } from 'lodash';
import { Redirect, Route } from 'react-router-dom';
import { branch, compose, mapProps, renderComponent } from 'recompose';

/**
 * Determines the appropriate redirection path for unauthorized users.
 *
 * Uses URL query 'auth=true' to trigger Keycloak sign-in redirect.
 */
const doUnauthorizedRedirection = () => {
  const useKCRedirection = window.location.href.includes('auth=true');

  if (useKCRedirection) {
    return '/auth/sign-in?auth=true';
  } else {
    return '/auth/sign-in';
  }
};

export default compose<any, any>(
  branch(
    ({ allow, ...props }) =>
      !!(isFunction(allow) ? allow() : get(props, allow)),
    renderComponent(Route)
  ),

  mapProps(({ allow, redirectTo, children, ...props }) => ({
    ...props,
    to: {
      pathname: (redirectTo && redirectTo) || doUnauthorizedRedirection(),
      state: { from: props.location },
    },
  }))
)(Redirect);

interface IProtectedLayout extends Route {
  allow: () => any | string;
  children?: any;
  path?: string;
  redirectTo?: string;
}
